import { useRef, useCallback, Fragment, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SelectTemplateDialog } from 'app/domains/templates';
import { FileUpload } from 'app/domains/upload';
export function ContextMenuButton(props) {
    const { disabled = false, onUploadFile, onCreateFolder, onUploadFolder } = props;
    const [renderTemplateDialog, setRenderTemplateDialog] = useState(false);
    const fileUploadRef = useRef(null);
    const showTemplateDialog = () => setRenderTemplateDialog(true);
    const hideTemplateDialog = () => setRenderTemplateDialog(false);
    const handleFileUpload = () => {
        var _a;
        (_a = fileUploadRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const handleFolderUpload = () => {
        if (onUploadFolder) {
            onUploadFolder();
        }
    };
    const handleCreateFolder = () => {
        if (onCreateFolder) {
            onCreateFolder();
        }
    };
    const handleCreateContract = () => {
        showTemplateDialog();
    };
    const handleFileChange = useCallback((event) => {
        const { files } = event.target;
        if (onUploadFile && files) {
            onUploadFile(Array.from(files));
        }
    }, [onUploadFile]);
    return (<Fragment>
      <Menu.Root target={<Button type="button" size="xs" disabled={disabled} appearance="primary">
            <Falcon icon="plus"/>
            <Trans>Add</Trans>
          </Button>}>
        {onUploadFile && (<Menu.Item onClick={handleFileUpload}>
            <Falcon icon="file-upload"/>
            <Trans comment="Filesystem Menu action item - upload a document to Miramis">Upload document</Trans>
          </Menu.Item>)}
        {onUploadFolder && (<Menu.Item onClick={handleFolderUpload}>
            <Falcon icon="folder-upload"/>
            <Trans comment="Filesystem Menu action item - upload documents to Miramis">Upload documents</Trans>
          </Menu.Item>)}
        <Menu.Item onClick={handleCreateContract}>
          <Falcon icon="file-alt"/>
          <Trans comment="Filesystem Menu action item - create a new contract using Miramis">New contract</Trans>
        </Menu.Item>
        {onCreateFolder && (<Menu.Item onClick={handleCreateFolder}>
            <Falcon icon="folder"/>
            <Trans comment="Filesystem Menu action item - create a new folder">New folder</Trans>
          </Menu.Item>)}
      </Menu.Root>
      <FileUpload onChange={handleFileChange} ref={fileUploadRef} multiple/>
      {renderTemplateDialog && <SelectTemplateDialog onClose={hideTemplateDialog}/>}
    </Fragment>);
}
